import Vue from 'vue'

const componentsContext = require.context('@/components', true, /\.(vue|ts|tsx)$/)

componentsContext.keys().forEach((component: any) => {
  const componentConfig = componentsContext(component)
  const ctrl = componentConfig.default || componentConfig
  if (ctrl.name) {
    Vue.component(ctrl.name, ctrl)
  }
})
